import React from "react"
import classnames from "classnames"
import { WINDOW, IS_IFRAME } from "AtomicUtils/environment"
import styles from "./BrowserHeightSection.less"
import { LoadingSection } from "AtomicComponents"
import debounce from 'AtomicUtils/debounce'

// BrowserHeightSection
// Sets the div to be the browserHeight
// withHeader -> minus header height
// withFooter -> minus footer Height

class BrowserHeightSection extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      height: 700,
      loading: true,
      visible: true,
    }
  }
  componentDidMount(){
    WINDOW.addEventListener("resize", debounce(this._setHeight, 250))
    this._setHeight()
    this.setState({
      loading: false
    }, () => {
      setTimeout(() => {
        this.setState({
          visible: false
        })
      }, 200);
    })
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("resize", debounce(this._setHeight,250));
  }

  _setHeight = () => {
    const { setHeight = () => {} } = this.props
    this.setState({
      height: `${this._calculatingHeight()}`,
    }, () => {
      setHeight(this.state.height)
    })
  }

  _calculatingHeight = () => {
    let newHeight = this.state.height

    // IN IS_IFRAME height is not limited to the browser
    if (!IS_IFRAME) {
      newHeight = Number(WINDOW.innerHeight)
      if (WINDOW && WINDOW.document){
        if (WINDOW.document.getElementById("header")){
          newHeight = Number(newHeight) - Number(WINDOW.document.getElementById("header").clientHeight)
        }
        if (WINDOW.document.getElementById("sticky-nav")){
          newHeight = Number(newHeight) - Number(WINDOW.document.getElementById("sticky-nav").clientHeight)
        }
      }
    }else {
      return 700
    }
    return newHeight
  }

  render() {
    const { children, styleName = "light" } = this.props
    const { height, loading, visible } = this.state
    return (
      <div
        className={classnames({
          [styles.BrowserHeightSection]: true
        })}
        style={{height: height+"px"}}
      >
        <div
          key={`BrowserHeightSection-${height}`}
          className={classnames({
            [styles.BrowserHeightChildren]: true,
            [styles.BrowserHeightChildrenVisible]: !loading
          })}
          style={{height: height+"px"}}
        >
          {children}
        </div>
        { visible &&
          <LoadingSection visible={loading} height={height} styleName={styleName} />
        }
      </div>
    )
  }
}


export default BrowserHeightSection



// WEBPACK FOOTER //
// ./src/AtomicContainers/BrowserHeightSection/BrowserHeightSection.jsx